import api from './api';

export interface RecentEntity {
  entity_id: string;
  entity_type: 'project' | 'sub_project' | 'kb';
  entity_name: string;
  last_accessed_at: string;
}

export interface RecentActivities {
  recent_projects: RecentEntity[];
  recent_sub_projects: RecentEntity[];
  recent_kbs: RecentEntity[];
}

export interface UserActivityCreate {
  entity_type: 'project' | 'sub_project' | 'kb';
  entity_id: string;
}

export const userActivityService = {
  /**
   * Log user activity when accessing an entity
   */
  async logActivity(data: UserActivityCreate): Promise<void> {
    try {
      await api.post('/user-activity/log', data);
    } catch (error) {
      // Silently fail - activity logging should not disrupt user experience
      console.warn('Failed to log user activity:', error);
    }
  },

  /**
   * Get recent activities for the current user
   */
  async getRecentActivities(): Promise<RecentActivities> {
    try {
      const response = await api.get<RecentActivities>('/user-activity/recent');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch recent activities:', error);
      // Return empty arrays on error
      return {
        recent_projects: [],
        recent_sub_projects: [],
        recent_kbs: []
      };
    }
  }
};
